export default {
  contractStatusList: [
    {
      label: '待生效',
      value: 1
    }, {
      label: '租期中',
      value: 2
    }, {
      label: '已到期',
      value: 3
    }, {
      label: '已变更',
      value: 4
    }, {
      label: '已退租',
      value: 6
    }, {
      label: '暂存',
      value: 7
    }, {
      label: '暂存',
      value: 17
    }
  ],
  pushTypeList: [
    {
      label: 'App',
      value: '1'
    },
    {
      label: '短信',
      value: '2'
    },
    {
      label: '邮件',
      value: '3'
    }
  ],
  archiveAuditStatusList: [
    {
      label: '审批中',
      value: 1
    },
    {
      label: '审批中',
      value: 2
    },
    {
      label: '审核通过',
      value: 3
    },
    {
      label: '审核不通过',
      value: 4
    }
  ],
  processStatusList: [
    {
      label: '送审中',
      value: 0
    },
    {
      label: '审批通过',
      value: 1
    },
    {
      label: '审批不通过',
      value: 2
    }
  ],
  confirmStatusList: [
    {
      label: '送审中',
      value: 1
    },
    {
      label: '审批通过',
      value: 2
    },
    {
      label: '审批不通过',
      value: 3
    }
  ],
  contractTypeList: [
    {
      label: '招商合同',
      value: 1
    }, {
      label: '公寓合同',
      value: 2
    }, {
      value: 3,
      label: '物业合同'
    }, {
      value: 6,
      label: '商业合同'
    }, {
      value: 61,
      label: '特殊商业合同'
    }
  ],
  twoYearRentalCycleList: [{
    label: '两年',
    value: 6
  }],
  rentalCycleList: [
    {
      label: '年',
      value: 4
    }, {
      label: '半年',
      value: 3
    }, {
      label: '季度',
      value: 2
    }, {
      label: '双月',
      value: 5
    }, {
      label: '月',
      value: 1
    }
  ],
  useTypeList: [
    { value: 1, label: '办公' },
    { value: 2, label: '商业' },
    { value: 3, label: '会议中心' },
    { value: 4, label: '餐厅' },
    { value: 5, label: '车库' },
    { value: 6, label: '库房' },
    { value: 7, label: '物业管理用房' },
    { value: 8, label: '值班室' },
    { value: 9, label: '住宅' },
    { value: 10, label: '酒店' },
    { value: 11, label: '储藏室' },
    { value: 12, label: '车位' },
    { value: 13, label: '厂房' }
  ],
  areaType: [
    { value: 1, label: '按建筑面积计费' },
    { value: 2, label: '按套内面积计费' },
    { value: 3, label: '按二次公摊后建筑面积计费' }
  ],
  feesTypeList: [{
    value: 0,
    label: '水费',
    unit: '元/吨'
  }, {
    value: 1,
    label: '电费',
    unit: '元/度'
  }],
  billTypeList: [{
    value: 1,
    label: '履约保证金'
  }, {
    value: 2,
    label: '首期租金'
  }, {
    value: 3,
    label: '租金'
  }, {
    value: 4,
    label: '免租/优惠期'
  }, {
    value: 5,
    label: '水费'
  }, {
    value: 6,
    label: '电费'
  }, {
    value: 7,
    label: '燃气费'
  }, {
    value: 8,
    label: '能源费预付款'
  }, {
    value: 9,
    label: '物业费'
  }, {
    value: 10,
    label: '首期物业费'
  }, {
    value: 12,
    label: '车位费'
  }, {
    value: 13,
    label: '供暖费'
  }, {
    value: 11,
    label: '退款'
  }, {
    value: 20,
    label: '违约金'
  }, {
    value: 31,
    label: '免租期'
  }],
  rateTypeList: [{
    value: 1,
    label: '租金'
  }, {
    value: 2,
    label: '物业费'
  }, {
    value: 3,
    label: '供暖费'
  }, {
    value: 4,
    label: '电费'
  }, {
    value: 5,
    label: '水费'
  }],
  accountContractTypeList: [{
    value: 1,
    label: '招商合同'
  }, {
    value: 2,
    label: '公寓合同'
  }, {
    value: 3,
    label: '物业合同'
  }, {
    value: 6,
    label: '商业合同'
  }, {
    value: 61,
    label: '特殊商业合同'
  }, {
    value: 3,
    label: '物业合同'
  }, {
    value: 4,
    label: '三方合同'
  }, {
    value: 41,
    label: '三方子合同'
  }],
  accountTypeList: [{
    value: 1,
    label: '一般户'
  }, {
    value: 1,
    label: '有钱户'
  }],
  houseStructureList: [
    { label: '01户型', value: 1 },
    { label: '02户型', value: 2 },
    { label: '03户型', value: 3 },
    { label: '04户型', value: 4 },
    { label: '05户型', value: 5 },
    { label: '06户型', value: 6 },
    { label: '07户型', value: 7 },
    { label: '08户型', value: 8 }
  ],
  flowStatusList: [
    { label: '暂存', value: 0 },
    { label: '审批中', value: 2 },
    { label: '已退回', value: 4 },
    { label: '审批通过', value: 3 }
  ],
  chargeTypeList: [
    { label: '租金', value: 1 },
    { label: '营业抽成', value: 2 },
    { label: '保底租金/营业抽成', value: 3 }
  ]
}



// WEBPACK FOOTER //
// ./src/area-contract/constants/contractConstant.js